import { generateSql } from '../../components/QueryBuilder/utils/sqlGenerator';

// Generate unique ID for field
const generateFieldId = () => {
  return `field_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};

// Add field action
export const _addField = (state, action) => {
  const newField = {
    id: generateFieldId(),
    tableName: '',
    tableFriendlyName: '',
    fieldName: '',
    fieldFriendlyName: '',
    operator: 'equals',
    criteria: '',
    dataType: 'string'
  };

  state.selectedFields = [...state.selectedFields, newField];
  state.generatedSql = generateSql(state.selectedFields);
  state.hasUnsavedChanges = true;
};

// Update field action
export const _updateField = (state, action) => {
  const { id, updates } = action.payload;

  state.selectedFields = state.selectedFields.map(field =>
    field.id === id ? { ...field, ...updates } : field
  );

  state.generatedSql = generateSql(state.selectedFields);
  state.hasUnsavedChanges = true;
};

// Remove field action
export const _removeField = (state, action) => {
  const fieldId = action.payload;

  state.selectedFields = state.selectedFields.filter(
    field => field.id !== fieldId
  );

  state.generatedSql = generateSql(state.selectedFields);
  state.hasUnsavedChanges = true;
};

// Reorder fields action
export const _reorderFields = (state, action) => {
  const { oldIndex, newIndex } = action.payload;

  // Reorder array
  const fields = [...state.selectedFields];
  const [movedField] = fields.splice(oldIndex, 1);
  fields.splice(newIndex, 0, movedField);

  state.selectedFields = fields;
  state.generatedSql = generateSql(fields);
  state.hasUnsavedChanges = true;
};

// Clear all fields action
export const _clearFields = (state) => {
  state.selectedFields = [];
  state.generatedSql = '';
  state.queryResults = null;
  state.error = null;
  state.successMessage = null;
  state.currentQueryId = null;
  state.hasUnsavedChanges = false;
};

// Set generated SQL action
export const _setGeneratedSql = (state, action) => {
  state.generatedSql = action.payload;
};

// Set loading state
export const _setLoading = (state, action) => {
  state.isLoading = action.payload;
};

// Set executing state
export const _setExecuting = (state, action) => {
  state.isExecuting = action.payload;
};

// Set query results
export const _setQueryResults = (state, action) => {
  state.queryResults = action.payload;
  state.error = null;
};

// Set error
export const _setError = (state, action) => {
  state.error = action.payload;
  state.queryResults = null;
};

// Set success message
export const _setSuccessMessage = (state, action) => {
  state.successMessage = action.payload;
};

// Clear error
export const _clearError = (state) => {
  state.error = null;
};

// Clear success message
export const _clearSuccessMessage = (state) => {
  state.successMessage = null;
};

// Reset state
export const _resetQueryBuilder = (state) => {
  return {
    selectedFields: [],
    generatedSql: '',
    isLoading: false,
    isExecuting: false,
    queryResults: null,
    error: null,
    successMessage: null,
    savedQueries: [],
    currentQueryId: null,
    hasUnsavedChanges: false
  };
};

// Load saved queries from localStorage
export const _loadSavedQueries = (state, action) => {
  state.savedQueries = action.payload;
};

// Load a query into the builder
export const _loadQuery = (state, action) => {
  const query = action.payload;
  state.selectedFields = query.selectedFields;
  state.generatedSql = generateSql(query.selectedFields);
  state.currentQueryId = query.id;
  state.hasUnsavedChanges = false;
  state.queryResults = null;
};

// Update saved queries list
export const _updateSavedQueries = (state, action) => {
  state.savedQueries = action.payload;
};

// Set current query ID
export const _setCurrentQueryId = (state, action) => {
  state.currentQueryId = action.payload;
  state.hasUnsavedChanges = false;
};

// Set unsaved changes flag
export const _setHasUnsavedChanges = (state, action) => {
  state.hasUnsavedChanges = action.payload;
};
